/**
 * DCMS FRONTEND API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { CommunicationDirectionEnum } from './communicationDirectionEnum';
import { CommunicationChannelEnum } from './communicationChannelEnum';


/**
 * A call, letter or note patient-ops log by hand.
 */
import {ValidatorFn, Validators} from "@angular/forms";

export interface CommunicationEntryWrite { 
    channel: CommunicationChannelEnum;
    direction: CommunicationDirectionEnum;
    occurredAt?: string;
    subject?: string;
    durationMinutes?: number | null;
    note?: string;
}
export namespace CommunicationEntryWrite {
}

export const CommunicationEntryWrite_channel_Validators: ValidatorFn[] =
    [  Validators.required, ];

export const CommunicationEntryWrite_direction_Validators: ValidatorFn[] =
    [  Validators.required, ];

export const CommunicationEntryWrite_occurredAt_Validators: ValidatorFn[] =
    [ ];

export const CommunicationEntryWrite_subject_Validators: ValidatorFn[] =
    [  Validators.maxLength(255),];

export const CommunicationEntryWrite_durationMinutes_Validators: ValidatorFn[] =
    [  Validators.min(0), Validators.max(1440),];

export const CommunicationEntryWrite_note_Validators: ValidatorFn[] =
    [ ];


